import { Redirect } from 'react-router-dom';
import { useAdventures } from '~/components/Adventure/Adventure.hooks';

export const AdventureRedirect = () => {
  const { data: [adventure] = [] } = useAdventures();
  const { id } = adventure || {};
  return id ? <Redirect to={`/adventure/${id}`} /> : null;
};
